import {Injectable} from '@angular/core';
import {EntityInvestmentTransactionListDto} from '@dto/holdings/entity-investment-transaction-list.dto';
import {EntityInvestmentTransactionViewModel} from '../view-models/entity-investment-transaction.view-model';
import {EntityInvestmentTransactionDto} from '@dto/holdings/entity-investment-transaction.dto';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';

@Injectable({
  providedIn: 'root'
})
export class EntityInvestmentTransactionConverterService {

  public convert(transactionList: EntityInvestmentTransactionListDto): EntityInvestmentTransactionViewModel[] {
    const transactions = transactionList.entityInvestmentTransactions;
    const lowestId = Math.min(...transactions.map(transaction => transaction.id));
    return transactions.map(transaction => this.convertSingle(transaction, lowestId));
  }

  private convertSingle(transaction: EntityInvestmentTransactionDto, lowestId: number): EntityInvestmentTransactionViewModel {
    const offsetId = transaction.id - lowestId; // Offset the numeric transaction ID by the lowest ID in this set of transactions
    const transactionDate = new Date(transaction.date);
    const offsetDate = new Date(transactionDate.getTime() + offsetId); // Add the transaction's offset ID as milliseconds to differentiate this transaction from others made on the same day

    return {
      date: offsetDate,
      type: transaction.type,
      description: transaction.description,
      amount: new FormattedNumber(transaction.amount),
    };
  }
}
